/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * aim-app/auth API
 * カスタマーの初回の作成およびカスタマー情報の設定、オペレーターのログイン、ログアウトを行う機能を提供します。
 * OpenAPI spec version: 2.0
 */

export type ProjectType = (typeof ProjectType)[keyof typeof ProjectType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectType = {
  UNSPECIFIED: 'UNSPECIFIED',
  CHAT: 'CHAT',
  VOICE: 'VOICE',
  INSTAGRAM: 'INSTAGRAM',
  LINE: 'LINE',
  LLMCHAT: 'LLMCHAT',
  SUMMARY: 'SUMMARY',
  DIALOG_ENGINE_VOICE: 'DIALOG_ENGINE_VOICE',
} as const;
